"use client";

import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";

export type FAQItem = {
  question: string;
  answer: string;
  /** Optional sanitised HTML answer (CMS articles); falls back to `answer`. */
  answerHtml?: string;
};

/** Wiederverwendbares FAQ-Akkordeon im Stil der Startseite. */
export default function FAQAccordion({ faqs }: { faqs: FAQItem[] }) {
  return (
    <Accordion.Root type="single" collapsible>
      {faqs.map(({ question, answer, answerHtml }, i) => (
        <Accordion.Item
          key={i}
          value={`item-${i}`}
          className="border-t border-line first:border-t-0"
        >
          <Accordion.Header>
            <Accordion.Trigger className="group flex w-full items-center justify-between gap-6 py-6 text-left cursor-pointer">
              <span className="font-display font-semibold text-lg text-ink group-hover:text-accent group-data-[state=open]:text-accent transition-colors duration-200">
                {question}
              </span>
              <Plus
                size={18}
                className="shrink-0 text-ink-faint transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:text-accent"
                aria-hidden="true"
              />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content forceMount className="accordion-content">
            {answerHtml ? (
              <div
                className="faq-html pb-6 pr-10 text-ink-soft leading-relaxed"
                dangerouslySetInnerHTML={{ __html: answerHtml }}
              />
            ) : (
              <p className="pb-6 pr-10 text-ink-soft leading-relaxed">{answer}</p>
            )}
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
}
